"use client"

import { Accordion } from "@base-ui/react/accordion"
import { PlusIcon } from "@heroicons/react/24/solid"
import Button from "../Button"

const faqItems = [
  {
    question: "What is near.com?",
    answer:
      "near.com is a platform that brings crypto, tokenized assets, earning, trading, and payments into one connected experience. Get started with a passkey or connect the wallet you already use.",
  },
  {
    question: "How do I create an account?",
    answer:
      "Use a passkey on your device, or connect an existing wallet. No email or KYC is required, and setup takes only a few seconds.",
  },
  {
    question: "How do cross-chain swaps work?",
    answer:
      "Choose what you have and what you want to receive. near.com finds a route across supported networks and completes the swap in one flow, without requiring you to bridge assets manually.",
  },
  {
    question: "What can I invest in through near.com?",
    answer:
      "near.com lets you invest in crypto and tokenized real-world assets, including equities and ETFs, from the same account.",
  },
  {
    question: "How do I earn interest on my assets?",
    answer:
      "You can earn through staking or by depositing into available yield vaults. Compare estimated rates, choose an option, and track your balance and earnings.",
  },
  {
    question: "Can my business integrate?",
    answer: (
      <>
        Yes. By integrating our technology, Ledger, SwapKit, and many others
        have processed billions in cross-chain swaps. Interested?{" "}
        <button
          type="button"
          className="text-gray-900 underline hover:text-gray-700"
          onClick={() => {
            if (typeof window !== "undefined" && window.Beacon) {
              window.Beacon("open")
            }
          }}
        >
          Reach out!
        </button>
      </>
    ),
  },
  {
    question: "Need help?",
    answer:
      "You got questions? We got answers! Contact support anytime. We usually respond within 24 hours.",
  },
]

const Faq = () => (
  <>
    <section className="mx-auto w-full max-w-7xl divide-y divide-black/11 border-black/11 border-x max-xl:border-none">
      <header className="flex flex-col items-start gap-4 px-6 pt-24 pb-16 sm:px-8 sm:pt-32">
        <h2 className="text-balance font-medium text-3xl/9 text-gray-900 tracking-tight lg:text-[2.5rem]/10">
          Frequently asked questions
        </h2>
        <p className="text-balance font-medium text-gray-500 text-lg/7">
          Can’t find your answer? Send us a note, and we’ll be in touch.
        </p>
        <Button
          size="lg"
          variant="light"
          onClick={() => {
            if (typeof window !== "undefined" && window.Beacon) {
              window.Beacon("open")
            }
          }}
        >
          Contact support
        </Button>
      </header>

      <Accordion.Root
        multiple
        className="divide-y divide-black/11 border-black/11 border-b"
      >
        {faqItems.map(({ question, answer }) => (
          <Accordion.Item
            key={question}
            className="relative transition-colors duration-150 data-open:bg-gray-50"
          >
            <Accordion.Header>
              <Accordion.Trigger className="group peer relative z-10 flex w-full items-start justify-between gap-4 px-6 py-6 text-left transition-[padding] duration-150 ease-[ease-out] focus-visible:outline-none data-panel-open:pb-3 sm:px-8">
                <span className="font-medium text-gray-900 text-xl/7 tracking-tight">
                  {question}
                </span>
                <span className="inline-flex h-7 shrink-0 items-center justify-center">
                  <PlusIcon className="size-6 text-gray-900 transition-transform duration-150 group-data-panel-open:rotate-45" />
                </span>
              </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Panel className="relative h-(--accordion-panel-height) overflow-hidden transition-[height] duration-150 ease-[ease-out] data-ending-style:h-0 data-starting-style:h-0">
              <div className="max-w-4xl text-balance px-6 pb-6 font-medium text-base/6 text-gray-500 sm:px-8">
                {answer}
              </div>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>

      <div className="mask-[url('/static/images/near-star-tile.svg')] mask-repeat mask-size-[21px_21px] h-32 bg-black/9" />
    </section>
  </>
)

export default Faq
